<template>
  <Modal
    :width="'600px'"
    :visible="props.visible"
    @update:visible="(v) => (v ? emits('update:visible', v) : close())"
    :footer="null"
    :title="null"
    :maskClosable="false"
    :wrapClassName="$style.Modal"
  >
    <div :class="$style.Container">
      <img
        :class="$style.Image"
        :src="
          isBuyLingdou
            ? 'https://static.lingvisions.com/public/f8cf0e9e7bb247f89dbbc72b94e5b38c.png'
            : 'https://static.lingvisions.com/public/5e6e34a2594d483591bf5d2c4a10b0b1.png'
        "
      />
      <div :class="$style.Title">支付成功</div>
      <div :class="$style.Content">
        <Header
          :avatarUrl="orgInfo?.logo"
          :title="orgInfo?.fullName"
          :isPersonal="isPersonal"
          :expireTime="lingdouInfo?.memberShip?.expireTime"
          :isVip="lingdouInfo?.memberShip?.member"
          :lingdouNum="lingdouInfo?.total"
          :avatarSize="isMobileUa ? 48 : 72"
          :showLingdou="isBuyLingdou"
          :showStorage="isBuyStorage"
          :showVip="!isBuyLingdou"
        />
        <div v-if="isBuyLingdou" :class="$style.LingdouDes">
          <div>本次充值</div>
          <div :class="$style.LingdouNum">
            +{{ tradeRightInfo?.amount }}
            <Lingdou style="margin-left: 2px" :size="16" />
          </div>
        </div>

        <div v-if="isBuyStorage">
          <div>本次充值</div>
          <div :class="$style.LingdouNum">
            +{{ tradeRightInfo?.capacityInfo.capacity }}GB({{
              tradeRightInfo?.capacityInfo.duration / 30
            }}月)
          </div>
        </div>
      </div>

      <div :class="$style.Content" style="margin-top: 12px" v-if="orgInfo?.qrCodeUrl">
        <div style="display: flex; align-items: center">
          <div :class="$style.QrcodeWrapper">
            <img
              src="https://static.lingvisions.com/public/892b38715fb14eb485d5751531d59280.png"
              style="width: 92px; height: 92px"
            />
          </div>

          <div :class="$style.QrcodeTitle" style="margin-left: 20px">扫码进入会员服务群</div>
        </div>
      </div>

      <div v-if="isMobileUa && props.showTip" :class="$style.Tip">
        若有需要，请前往PC端查看订单、开具发票。
      </div>
      <div :class="$style.Footer" v-if="props.showFooter">
        <Button @click="handleCancel" v-if="!isMobileUa" style="margin-right: 24px">
          {{ props.cancelText }}
        </Button>
        <Button :class="$style.OkBtn" @click="handleOk" type="primary">{{ props.okText }}</Button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
  import { ref, watch, computed } from 'vue';
  import { Modal, Button } from 'ant-design-vue';
  import Header from '../components/header.vue';
  import { getApi } from '../init';
  import { getIsMobileUa } from '@lingtu/tools';
  import { ORG_TYPE } from '../constants';
  import Lingdou from '../components/lingdou.vue';

  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },

    getOrgInfo: {
      type: Function,
      default: null,
    },

    getLingdouInfo: {
      type: Function,
      default: null,
    },

    tradeNo: {
      type: Number,
      default: null,
    },

    okText: {
      type: String,
      default: '去使用',
    },

    cancelText: {
      type: String,
      default: '订单发票',
    },

    onOk: {
      type: Function,
      default: () => {},
    },

    onCancel: {
      type: Function,
      default: () => {},
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    showTip: {
      type: Boolean,
      default: true,
    },

    showFooter: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(['update:visible']);
  const orgInfo = ref();
  const lingdouInfo = ref();
  const tradeRightInfo = ref();
  const isMobileUa = getIsMobileUa();
  const isBuyLingdou = computed(() => tradeRightInfo.value?.amount);
  const isBuyStorage = computed(() => tradeRightInfo.value?.capacityInfo);

  const isPersonal = computed(() =>
    orgInfo.value ? orgInfo.value.type === ORG_TYPE.PERSONAL : true
  );

  async function init() {
    const result = await Promise.all([
      props.getOrgInfo?.(),
      props.getLingdouInfo?.(),
      getApi().aiadTransactionsApi.getTradeRightByTradeNo({
        tradeNo: props.tradeNo,
      }),
    ]);
    orgInfo.value = result[0];
    lingdouInfo.value = result[1];
    tradeRightInfo.value = result[2];
  }
  function close() {
    props?.onClose();
    emits('update:visible', false);
  }
  function handleOk() {
    props?.onOk();
    emits('update:visible', false);
  }
  function handleCancel() {
    props?.onCancel();
    emits('update:visible', false);
  }

  watch(
    () => props.visible,
    (v) => {
      if (v) {
        init();
      }
    },
    {
      immediate: true,
    }
  );
</script>

<style lang="less" module>
  .Modal {
    padding: 0;

    :global {
      .ant-modal-body {
        padding: 40px 24px 24px;
      }
    }
  }

  .Container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .Title {
    font-size: 32px;
    font-weight: 600;
    line-height: 32px;
    color: rgba(255, 255, 255, 0.85);
  }

  .Amount {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.85);

    > span {
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      color: rgba(255, 177, 27, 1);
      margin-left: 8px;
    }
  }

  .Content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: rgba(40, 40, 40, 1);
    margin-top: 24px;
    border-radius: 4px;
  }

  .QrcodeWrapper {
    width: 100px;
    height: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .QrcodeTitle {
    font-family: PingFang SC;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: rgba(255, 255, 255, 0.85);
  }

  .Footer {
    display: flex;
    align-items: center;
    margin-top: 40px;

    button {
      width: 120px;
      height: 40px;
    }
  }

  .Image {
    width: 180px;
    height: 120px;
    margin-bottom: 16px;
  }

  .Tip {
    width: 100%;
    margin-top: 12px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.45);
  }

  .LingdouDes {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;

    color: rgba(255, 255, 255, 0.85);
  }

  .LingdouNum {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 8px;
    color: rgba(255, 177, 27, 1);
  }

  @media (max-width: 500px) {
    .Modal {
      padding: 0;

      :global {
        .ant-modal {
          max-width: unset;
          width: 100vw !important;
          height: 100vh;
          top: 0;
          margin: 0;
          padding: 0 !important;
        }

        .ant-modal-content {
          height: 100vh;
          box-shadow: unset !important;
        }

        .ant-modal-body {
          padding: 48px 16px 0;
          height: 100vh;
        }
      }
    }

    .Title {
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
    }

    .Image {
      width: 90px;
      height: 60px;
    }

    .Amount {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }

    .Footer {
      margin-top: 30px;
    }

    .OkBtn {
      width: 176px !important;
      height: 40px !important;
      background-color: rgba(209, 108, 68, 1) !important;
    }

    .LingdouDes {
      font-size: 12px;
      font-weight: 600;
      line-height: 22px;
    }

    .LingdouNum {
      font-size: 16px;
      font-weight: 600;
      line-height: 16px;
      margin-top: 4px;
    }
  }
</style>
